import { render, staticRenderFns } from "./TripConfigurations.vue?vue&type=template&id=1676001a&"
import script from "./TripConfigurations.vue?vue&type=script&lang=js&"
export * from "./TripConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports